// Aviso da lista vazia quando quem esvaziou foi o "Esconder ja comprei nesta rodada" (DA-368):
// sem ele a tela parecia uma cotacao sem produto. Arquivo proprio porque as duas vistas
// (Por produto e Lado a lado) usam, e uma nao importa da outra.
export function AvisoOcultosComprados({ qtd, onMostrar }: { qtd: number; onMostrar: () => void }) {
  return (
    <div style={{ marginTop: 6 }}>
      {qtd === 1 ? '1 produto escondido' : `${qtd} produtos escondidos`} por “Esconder já comprei nesta rodada” (comprado depois que a cotação foi aberta).
      <button type="button" className="btn-primario" style={{ marginLeft: 8, padding: '4px 12px', fontSize: 13 }} onClick={onMostrar}>
        Mostrar
      </button>
    </div>
  );
}
